import AlertGroupTypes from 'store/actionTypes/alertGroup'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  system: [],
  pagination: {}
}

const AlertGroup = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AlertGroupTypes.GET_ALERT_GROUPS_SUCCESS:
      return {
        ...state,
        list: payload?.items || [],
        pagination: payload?.meta
      }
    case AlertGroupTypes.GET_ALERT_GROUP_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload || []
      }
    case AlertGroupTypes.GET_SYSTEM_ALERT_GROUPS_SUCCESS:
      return {
        ...state,
        system: payload?.items || []
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default AlertGroup
